import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import moment from "moment";
import { useSelector } from "react-redux";
import AdminDiamondReportService from "../../../services/reports-AdminDiamond-service";
import AdminDiamondColorSearchesComp from "../../AdminChartsGroup/AdminDiamondColorSearchesComp";
import { Button, DatePicker, Select, Spin, Table, Tooltip } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logoImg from "../../../assets/images/logo-img.png";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
const { RangePicker } = DatePicker;
const { Option } = Select;

const DiamondColor = () => {
  const { t } = useTranslation();
  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  const [TableShapeValue, setTableShapeValue] = useState("");
  const [TableClarityValue, setTableClarityValue] = useState("");
  const [TableCutGradeValue, setTableCutGradeValue] = useState("");
  const [TableColorValue, setTableColorValue] = useState("");
  const [TableSizeValue, setTableSizeValue] = useState("");
  const [TableCertificateValue, setTableCertificateValue] = useState("");
 const [CSVLoading, setCSVLoading] = useState(false);
  const [PDFLoading, setPDFLoading] = useState(false);
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [forDealer, setForDealer] = useState("");
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [TotalDiamondRecords, setTotalDiamondRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [sortOrderCol, setsortOrderCol] = useState("date");
  const [sortOrderType, setsortOrderType] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [DiamondColorTableList, setDiamondColorTableList] = useState([]);
  const [key, setKey] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [paginationPage, setPaginationPage] = useState(1);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  // Handle chart click - refresh table when color value changes
  useEffect(() => {
    if (TableColorValue && dealerId && forDealer) {
      handleGetDiamondColorList(
        dealerId,
        forDealer,
        1,
        pageSize,
        sortOrderCol,
        sortOrderType,
        TableColorValue
      );
    }
  }, [TableColorValue]);

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  };

  const handleCheckDealermembers = (id) => {
    let inputData = {
      dealerID: id,
    };

    AdminDiamondReportService.CheckDealermembers(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var forDealer = responseData.forDealer;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setForDealer(forDealer);
          } else {
            setForDealer("");
          }
          handleLoadChartReports(id, forDealer);
          handleGetDiamondColorList(
            id,
            forDealer,
            pageNo,
            pageSize,
            sortOrderCol,
            sortOrderType
          );
        } else {
          setForDealer("");
        }
      })
      .catch((error) => {
        setForDealer("");
      });
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "Global",
      reportName: "Color",
    };
    setLoadChartReportsLoading(true);

    AdminDiamondReportService.LoadChartReports(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var TotalDiamondClicks =
          responseData.TotalDiamondClicks[0].TotalClickCnt;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setTotalDiamondClicks(TotalDiamondClicks);
            setKey(!key);
          }
        } else {
          setTotalDiamondClicks([]);
        }
      })
      .catch((error) => {
        setLoadChartReportsLoading(false);
        setTotalDiamondClicks([]);
        console.log(error);
      })
      .finally(() => setLoadChartReportsLoading(false));
  };

  const handleGetDiamondColorList = (
    dealerId,
    forDealer,
    pageNo,
    pageSize,
    sortOrderCol,
    sortOrderType,
    TableColorValue
  ) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: TableCutGradeValue,
      shape: TableShapeValue,
      color: TableColorValue ? TableColorValue : "",
      size: TableSizeValue,
      certificate: TableCertificateValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: sortOrderCol || "date",
      sortOrderType: sortOrderType || "DESC",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      reporttype: "Global",
      reportName: "Color",
    };

    setLoading(true);
    setTableColorValue(TableColorValue);
    AdminDiamondReportService.GetAllChartForTableList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setDiamondColorTableList(
            responseData.getDiamondReportForTableChartAll20resp
          );
          setTotalDiamondRecords(responseData.totalRows);
          setKey(!key);
        } else {
          setDiamondColorTableList([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => setLoading(false));
  };


  const handleDownloadCSVReports = () => {
    
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: TableCutGradeValue,
      shape: TableShapeValue,
      color: TableColorValue ? TableColorValue : "",
      size: TableSizeValue,
      certificate: TableCertificateValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: sortOrderCol || "date",
      sortOrderType: sortOrderType || "DESC",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      reporttype: "Global",
      reportName: "Color",
    };

    setCSVLoading(true);
    setTableColorValue(TableColorValue);
    AdminDiamondReportService.GetCSVChartForTableList(inputData)
      .then((response) => {
        setCSVLoading(false);
        var fileName =
          "DiamondColor_Report" +
          new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
          ".csv";
        BlobToDownloadFile(response.data, fileName);
      })
      .catch((error) => {
        setCSVLoading(false);
      });
  };

  const handleDownloadPDFReports = () => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: TableCutGradeValue,
      shape: TableShapeValue,
      color: TableColorValue ? TableColorValue : "",
      size: TableSizeValue,
      certificate: TableCertificateValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: sortOrderCol || "date",
      sortOrderType: sortOrderType || "DESC",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      reporttype: "Global",
      reportName: "Color",
    };

    setPDFLoading(true);
    AdminDiamondReportService.GetPDFChartForTableList(inputData)
      .then((response) => {
        setPDFLoading(false);
        var fileName =
          "DiamondColor_Report" +
          new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
          ".pdf";
        BlobToDownloadFile(response.data, fileName, "pdf");
      })
      .catch((error) => {
        setPDFLoading(false);
      });
  };

  const handleApplyFilter = () => {
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setsortOrderType(type);
      setsortOrderCol(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setsortOrderType(type);
      setsortOrderCol(column);
    } else {
      type = "DESC";
      column = "date";
      setsortOrderCol(column);
      setsortOrderType(type);
    }

    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);

    handleGetDiamondColorList(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type,
      TableColorValue
    );
  };

   const options = {
    is3D: true,
    pieHole: 0.5,
    pieSliceText: "percentage",
    tooltip: { trigger: "focus", text: "text" },
    chartArea: { left: "10%", top: "5%", width: "80%", height: "90%" },
    colors: colorData,
    legend: { position: "none" },
  }

  const handleDownloadPieChart = async () => {
    try {
      // Step 1: Prepare PDF-specific PieChart options
      const pdfChartOptions = {
        ...options,
        width: 1800,
        height: 950,
        chartArea: { left: 50, top: 140, width: "100%", height: "100%" },
        legend: { position: "none" }, // we'll add custom legend manually
        pieHole: 0.4,
        pieSliceText: "percentage",
        tooltip: { text: "percentage" },
        pieSliceTextStyle: { fontSize: 18, color: "#000" },
      };

      // Step 2: Create a hidden container
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-piechart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // Step 3: Create dynamic custom legends
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "space-evenly";
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      chartData.slice(1).forEach((row, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "18px";
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = colorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const labelText = row[0].replace(/\s*\([^)]*\)\s*/g, "");
        const valueText = ` (${row[1]})`;

        const textNode = document.createTextNode(labelText + valueText);
        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // Step 4: Add chart container
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "900px";
      hiddenContainer.appendChild(chartDiv);

      // Step 5: Draw the pie chart in the hidden div
      const tempChart = new window.google.visualization.PieChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(chartData);
      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // Step 6: Capture legend + chart together
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");

      // Step 7: Clean up
      document.body.removeChild(hiddenContainer);

      // Step 8: Build PDF structure
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;
      const infoBlockHeight = 15;
      const availableHeight =
        pageHeight - headerHeight - footerHeight - infoBlockHeight - 6;

      // Header
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("DIAMOND COLOR REPORT", pageWidth - margin, 11, { align: "right" });

      // Info Line (flex-like in one line)
       pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
        "MMM DD, YYYY"
      )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`;

      const selectedDiamondLabel =
        globalDiamonds.SelectedDiamondValue === "All"
          ? "All Diamonds"
          : globalDiamonds.SelectedDiamondValue === "Mined"
            ? "Mined Diamonds"
            : "Lab Grown Diamonds";

      const diamondType = `Selected Diamond: ${selectedDiamondLabel}`;
      const clicks = `Total Clicks: ${TotalDiamondClicks?.toLocaleString() || 0}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        diamondType,
        clicks
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // Split text dynamically to fit within the maxWidth
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      // Display each line with proper spacing
      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // Chart Image
      const imgRatio = canvas.width / canvas.height;
      let imgWidthMM = pageWidth - margin * 3;
      let imgHeightMM = imgWidthMM / imgRatio;
      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      const xPos = margin;
      const yPos = currentY; 
      pdf.addImage(imgData, "PNG", xPos, yPos, imgWidthMM, imgHeightMM, undefined, "FAST");

      // Footer
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);
      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;
      pdf.text(footerText, pageWidth / 2, pageHeight - footerHeight / 2 + 2, {
        align: "center",
      });

      // --- WATERMARK ---
      const watermarkText = "JewelCloud";
      pdf.setFontSize(90);
      pdf.setFont(undefined, "bolditalic");
      pdf.setTextColor(102, 102, 102);

      pdf.saveGraphicsState();
      pdf.setGState(pdf.GState({ opacity: 0.1 }));

      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;

      const textWidth = pdf.getTextWidth(watermarkText);
      const textHeight =
        pdf.internal.getFontSize() / pdf.internal.scaleFactor;

      const angleRad = (45 * Math.PI) / 180;
      const rotatedWidth =
        textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
      const rotatedHeight =
        textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

      const xPosWatermark = centerX - rotatedWidth / 2;
      const yPosWatermark = centerY + rotatedHeight / 4 + 40;

      pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });

      pdf.restoreGraphicsState();

      pdf.save("Diamond-Color-Search-Report.pdf");

    } catch (err) {
      console.error("Error generating Pie Chart PDF:", err);
    }
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Diamond Color Report")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label> {t("Date Range")} </label>

              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                className="border__grey"
                placeholder={t("All")}
                showSearch
                name="SelectedDiamondValue"
                optionFilterProp="children"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              >
                <Option value="All">{t("All")}</Option>
                <Option value="Mined">{t("Mined Diamond")}</Option>
                <Option value="Lab">{t("Lab Grown Diamond")}</Option>
              </Select>
            </div>
          </div>

          {DiamondColorTableList && DiamondColorTableList.length > 0 && (
            <div className="col-lg-12 col-md-6 mt-4">
              <div className="input__block">
                <label>
                  <Spin spinning={LoadChartReportsLoading} size="small">
                    <b>
                      {" "}
                      {t("Total Clicks")} :{" "}
                      {TotalDiamondClicks ? TotalDiamondClicks : 0}
                    </b>
                  </Spin>
                </label>
              </div>
            </div>
          )}
          <div className="col-md-12 mt-2">
            <div className="input__block">
              <button
                className="primary-btn mobile-mt-0"
                onClick={handleApplyFilter}
              >
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="chart__section" style={{ display: "flex", justifyContent: "center" }}>
              <div id="pdf-content" >
                {forDealer && (
                  <AdminDiamondColorSearchesComp
                    globalDiamonds={globalDiamonds}
                    mainForDealer={forDealer}
                    isApplyFilter={isApplyFilter}
                    pageNo={pageNo}
                    pageSize={pageSize}
                    sortOrderCol={sortOrderCol}
                    sortOrderType={sortOrderType}
                    setPageNo={setPageNo}
                    handleGetDiamondColorList={handleGetDiamondColorList}
                    setChartData={setChartData}
                    chartData={chartData}
                    setColorData={setColorData}
                    colorData={colorData}
                    options={options}
                    setTableColorValue={setTableColorValue}
                    setPaginationPage={setPaginationPage}
                  />
                )}

              </div>

            </div>
          </div>

          <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
            {forDealer && (
              <>
                <Button
                  className="primary-btn mb-2 mb-lg-0 mr-2"
                  onClick={handleDownloadPieChart}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download Chart")}
                </Button>
                <Button
                  className="primary-btn mb-2 mb-lg-0 mr-2"
                  onClick={handleDownloadPDFReports}
                  loading={PDFLoading}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download PDF")}
                </Button>
                <Button
                  className="primary-btn"
                  onClick={handleDownloadCSVReports}
                  loading={CSVLoading}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download CSV")}
                </Button>
              </>

            )}
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                  scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              columns={[
                {
                  title: (
                    <Tooltip title={t("UsersIPAddress")}>
                      {t("UsersIPAddress")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "usersIPAddress",
                  sorter: {},
                  render: (item, row) => {
                    return (
                      <div>
                        {row.usersIPAddress === "::1" ? (
                          <span>-</span>
                        ) : (
                          <span>{row.usersIPAddress}</span>
                        )}
                      </div>
                    );
                  },
                },
                {
                  title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "date",
                  defaultSortOrder: "descend",
                  sorter: {},
                  render: (row, item) => {
                    if (Object.keys(item.date).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>
                            {moment(item.date).format("MM-DD-YYYY, hh:mm:ss A")}
                          </span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "shape",
                  sorter: {},
                },
                {
                  title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "size",
                  sorter: {},
                },
                {
                  title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "color",
                  sorter: {},
                },
                {
                  title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "cutGrade",
                  sorter: {},
                },
                {
                  title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "clarity",
                  sorter: {},
                },
                {
                  title: (
                    <Tooltip title={t("Certificates")}>
                      {t("Certificates")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "certificate",
                  sorter: {},
                },
                {
                  title: (
                    <Tooltip title={t("Retail Price")}>
                      {t("Retail Price")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "retailPrice",
                  sorter: {},
                  render: (retailPrice) => (
                    <Tooltip title={retailPrice}>
                      <span>{retailPrice}</span>
                    </Tooltip>
                  ),
                },
                {
                  title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "cost",
                  sorter: {},
                  render: (cost) => (
                    <Tooltip title={cost}>
                      <span>{cost}</span>
                    </Tooltip>
                  ),
                },
              ]}
              loading={loading}
              dataSource={DiamondColorTableList}
              pagination={{
                size: "small",
                total: TotalDiamondRecords,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
                current: paginationPage,
                onChange: (pageNum) => setPaginationPage(pageNum),
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondColor;
